export default IconCurling => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-curling" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 9m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v2a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
  <path d="M4 14h16" />
  <path d="M8 5h6a2 2 0 0 1 2 2v2" />
</svg>`;